<template>
  <div>
    <!-- 用户信息工具栏 -->
    <div class="user-wrapper">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar
            class="avatar"
            icon="user"
            size="small"
          />

          <span>您好，{{getUserName()}}</span>
        </span>
        <a-menu
          slot="overlay"
          class="user-dropdown-menu-wrapper"
        >
          <!-- <a-menu-item key="1">
            <a
              href="javascript:;"
              @click="handleChangePassword"
            >
              <a-icon type="edit" />&ensp;
              <span>修改密码</span>
            </a>
          </a-menu-item>
          <a-menu-divider /> -->
          <a-menu-item key="3">
            <a
              href="javascript:;"
              @click="handleLogout"
            >
              <a-icon type="logout" />&ensp;
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <!-- 修改密码 -->
    <change-password-modal
      :visible="passwordModalVisible"
      :confirmLoading="passwordModalConfirmLoading"
      @submit="passwordModalSubmit"
      @cancel="passwordModalCancel"
    ></change-password-modal>
  </div>
</template>

<script>
import { storage } from '@/utils/base'
import changePasswordModal from '@/components/userInfo/change-password'

export default {
  data () {
    return {
      passwordModalVisible: false,
      passwordModalConfirmLoading: false
    }
  },
  methods: {
    // 获取用户信息
    getUserName () {
      return storage.get('user').name ? storage.get('user').name : ''
    },
    // 修改密码
    handleChangePassword () {
      this.passwordModalVisible = true
    },
    // 取消修改密码
    passwordModalCancel () {
      this.passwordModalVisible = false
    },
    // 修改密码提交
    passwordModalSubmit (form) {
      form.validateFields(
        (err, values) => {
          if (!err) {
            this.passwordModalConfirmLoading = true
          }
        }
      )
    },
    // 退出登录
    handleLogout () {
      let that = this
      that.$confirm({
        title: '您确定要退出系统吗?',
        onOk () {
          storage.remove('token')
          storage.remove('user')
          if (!storage.get('token')) {
            setTimeout(() => {
              that.$router.push({ path: '/' })
            })
          } else {
            that.$message.warn('退出失败')
          }
        }
      })
    }
  },
  components: {
    changePasswordModal
  }

}
</script>

<style lang="less" scoped>
.user-wrapper {
  float: right;
  height: 100%;

  .action {
    cursor: pointer;
    padding: 0 12px;
    display: inline-block;
    transition: all 0.3s;
    height: 100%;
    color: rgba(0, 0, 0, 0.65);

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }

    .avatar {
      margin: 18px 8px 20px 0;
      color: #fff;
      background: rgba(215, 215, 215, 1);
      vertical-align: middle;
    }

    .icon {
      font-size: 16px;
      padding: 4px;
    }
  }
}
</style>
